import React from "react"
import { View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseFontFamily } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import SavoirFaireTopTabStack from "@Navigation/TopTabBarStack/SavoirFaireTopTabStack/SavoirFaireTopTabStack"

const SavoirFaire = () => {
    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <BreeSerifText style={styles.headerTile} fontSize={24}>
                    Savoir-Faire
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={16}>
                    Retrouvez des articles, des vidéos et des ateliers en direct.
                </OpenSansText>
            </View>
            <SavoirFaireTopTabStack />
        </View>
    )
}

export default SavoirFaire
